import requestLog from './message/requestLog'
import scheduling from './message/scheduling'

import {defineI18nCreate} from "@verdure/core";

export default defineI18nCreate([
    requestLog,
    scheduling
])
